import {Pipe, PipeTransform} from '@angular/core';
import {Duration} from 'luxon';


@Pipe({
    name: 'formatDuration',
    standalone: true
})
export class FormatDurationPipe implements PipeTransform {
  transform(value: number, type: 'hours' | 'minutes'): string {
    if (value == null || Number.isNaN(value)) {
      value = 0;
    }

    const minutes = Math.abs(type === 'minutes' ? value : Math.round(value * 60));

    return (value < 0 ? '- ' : '') + Duration.fromObject({minutes}).toFormat('h:mm');
  }
}
